import { render, staticRenderFns } from "./terminals.vue?vue&type=template&id=7868d6e5&scoped=true"
import script from "./terminals.vue?vue&type=script&lang=js"
export * from "./terminals.vue?vue&type=script&lang=js"
import style0 from "./terminals.vue?vue&type=style&index=0&id=7868d6e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7868d6e5",
  null
  
)

export default component.exports